import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Restangular } from 'ngx-restangular';

@Injectable()
export class StatisticsService {
    constructor(private restangular: Restangular) {
    }

    getSmsReceivedCount(): Observable<any> {
        return this.restangular.one('statistics/sms/received/count').customGET("");
    }

    getSmsSentCount(): Observable<any> {
        return this.restangular.one('statistics/sms/sent/count').customGET("");
    }

    getSmsServerCount(): Observable<any> {
        return this.restangular.one('statistics/sms/server/count').customGET("");
    }

    getBoundServerCount(): Observable<any> {
        return this.restangular.one('statistics/sms/server/bound/count').customGET("");
    }

    getReceivedCountDaySummary(): Observable<any> {
        return this.restangular.one('statistics/sms/received/summary').customGET("");
    }

    getSentCountDaySummary(): Observable<any> {
        return this.restangular.one('statistics/sms/sent/summary').customGET("");
    }

    getEsmeServerStatus(): Observable<any> {
        return this.restangular.one('statistics/esme/server/status').customGET("");
    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/services/statististics.service.ts